
import React from 'react';
import { Slider } from '@/components/ui/slider';
import { Button } from '@/components/ui/button';
import { formatTime, minutesToSliderValue, sliderValueToMinutes } from '../utils/chartUtils';

interface GoalSettingSectionProps {
  dailyTarget: number;
  tempGoal: number;
  setTempGoal: (goal: number) => void;
  isSaving: boolean;
  onGoalUpdate: () => void;
}

const GoalSettingSection: React.FC<GoalSettingSectionProps> = ({
  dailyTarget,
  tempGoal,
  setTempGoal,
  isSaving,
  onGoalUpdate
}) => {
  return (
    <div className="bg-gray-50 dark:bg-gray-800/50 p-4 rounded-lg space-y-4">
      <div>
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
          Daily Focus Goal
        </span>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          This helps us track your progress and keep you motivated.
        </p>
      </div>
      
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="text-sm text-gray-600 dark:text-gray-400">
            {formatTime(tempGoal)}
          </div>
        </div>
        
        <div className="w-full px-2">
          <Slider
            value={[minutesToSliderValue(tempGoal)]}
            onValueChange={(value) => setTempGoal(sliderValueToMinutes(value[0]))}
            min={1}
            max={16}
            step={1}
            className="w-full"
            disabled={isSaving}
          />
          
          <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400 mt-1">
            <span>30m</span>
            <span>8h</span>
          </div>
        </div>
        
        <div className="flex justify-start">
          <Button
            onClick={onGoalUpdate}
            disabled={isSaving || tempGoal === dailyTarget}
            size="sm"
            className="w-fit"
          >
            {isSaving ? 'Updating...' : 'Update Goal'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GoalSettingSection;
